import { Link, Space } from '@kl/components-v6';
import { LocalizedText } from '../localized-text';
import { StyledKSCLogo } from './styled';
import { useInitialInfo } from 'shared/api/use-initial-info';
import { KNextIcon } from '../icons';

export const KscLogo = () => {
    const { isKscMode, isFetching } = useInitialInfo();

    return (
        <StyledKSCLogo>
            <Link href="/">
                <Space direction="horizontal" size={5}>
                    <KNextIcon />
                    {!isFetching && (
                        <LocalizedText
                            localizationKey={isKscMode ? 'KscccTitle' : 'KNextTitle'}
                            type="BTM3"
                        />
                    )}
                </Space>
            </Link>
        </StyledKSCLogo>
    );
};
